<script setup>
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import BellIcon from "@/components/shared/icons/BellIcon.vue";
import { computed } from "vue";

const accordianDefinitions = [
  {
    index: 0,
    key: "reminders",
    title: "Reminders & Updates",
    enabled: true,
    count: 0,
  },
  {
    index: 1,
    key: "todos",
    title: "Required To-Dos",
    enabled: true,
    count: 0,
  },
  {
    index: 2,
    key: "invoices",
    title: "Invoices",
    enabled: true,
    count: 0,
  },
  {
    index: 3,
    key: "missed",
    title: "What You Might Have Missed",
    enabled: false,
    count: 0,
  },
];

const activeAccordianDefinitions = computed(() => accordianDefinitions.filter((definition) => definition.enabled));

const initialOpenTabs = computed(() => {
  return [...activeAccordianDefinitions.value.keys()];
});

const ptStylingAccordionTab = (index) => {
  return {
    toggleableContent: {
      class: "",
    },
    content: {
      class: "bg-white border-0 py-4 px-6",
    },
    header: {
      class: "p-4 bg-white",
    },
    headerTitle: {
      class: "font-montserrat font-bold text-base text-[#334155]",
    },
    headerIcon: {
      class: "absolute right-0",
    },
  };
};
</script>
<template>
  <Accordion :active-index="initialOpenTabs" :multiple="true" data-testid="experience-detail-accordion">
    <AccordionTab
      v-for="(panelDefinition, index) in activeAccordianDefinitions"
      :key="panelDefinition.key"
      :value="panelDefinition.index"
      :pt="ptStylingAccordionTab(index)"
      :data-testid="`experience-detail-tab-${index}`"
    >
      <template #header>
        <div class="flex items-center flex-wrap text-[#334155]">
          <BellIcon v-if="panelDefinition.key === 'reminders'" class="mr-1" />
          <span class="text-base font-bold normal-case"
            >{{ panelDefinition.title }} ({{ panelDefinition.count }})</span
          >
        </div>
      </template>
    </AccordionTab>
  </Accordion>
</template>
